import { Form, FormItemProps, Switch, SwitchProps } from 'antd';

interface SwitchFormProps {
  formProps?: FormItemProps;
  switchProps?: SwitchProps;
}

export const SwitchForm = ({ formProps, switchProps }: SwitchFormProps) => (
  <Form.Item 
    {...formProps}
    hasFeedback={formProps?.hasFeedback !== undefined ? formProps.hasFeedback : true}
  >
    <Switch {...switchProps} />
  </Form.Item>
);
